
<div class="user-profile-detail my-wishlist-detail">
    <div class="right-icon d-lg-none d-flex">
        <a (click)="backClick()"><img src="assets/images/right-arrow-user.svg" alt="icon"></a>
        <h4 class="d-lg-none d-block">My Wishlist</h4>
    </div>
    
        <div class="row" *ngIf="mWishlistData && mWishlistData.length > 0">
            <div class="col-sm-4  item" *ngFor="let wishList of mWishlistData; let i  = index" >
                <app-product-box [color]="wishList?.productdetail?.category?.color" [product]="wishList" [mAddUpdateCartModule]="mAddUpdateCartModule" [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse" [mWishlistData]="mWishlistData"  [productType]="'wishlist'"></app-product-box>
            </div>
        </div>

          <div class="empty-card-new" *ngIf="mWishlistData.length < 1">
            <div class="empty-card">
              <div class="empty-card-icon">
                <img src="assets/images/wishlist-empty.svg" alt="icon">
              </div>
              <span>No items in your wishlist</span>
              <small>Add items to wishlist now!</small>
            </div>
            <a routerLink="/shop-all" class="start-btn">Add items to wishlist</a>
          </div>
</div>